import paymentDetail from "./paymentDetail.vue";
export default paymentDetail;
